import cn from "classnames";
import { useEffect, memo, isValidElement } from "react";
import { Close as CloseIcon } from "@rshbintech.dboul/icons";
import { Text } from "../../text";
import { Button } from "../../button";
import { useMediaQuery } from "../../grid";
import { useTimer } from "../hooks/use-timer";
import { NOTIFICATION_ICONS } from "./constants";
import { NotificationProps } from "./types";
import styles from "./styles.module.scss";

export const Notification = memo(
  ({
    type = "default",
    content,
    timeout,
    onClick,
    onClose,
    notificationId,
    closeNotification,
  }: NotificationProps) => {
    const isMobile = useMediaQuery("mobile");

    const handleClose = () => {
      closeNotification?.(notificationId);
      onClose?.();
    };

    const handleCloseByTimeout = () => {
      closeNotification?.(notificationId);
    };

    // TODO: Изменить текущую логику работы с таймером, чтобы обращаться к нему только при наличии timeout и не писать обходные решения в стиле conditional hook (http://sdlc.go.rshbank.ru/jira/browse/OB_COREUI-90).
    const timer = useTimer(handleCloseByTimeout, timeout);

    const handleMouseEnter = () => {
      timer?.pause();
    };

    const handleMouseLeave = () => {
      timer?.resume();
    };

    useEffect(() => timer?.stop, []);

    return (
      <div
        className={cn(styles.notification, styles[type], {
          [styles.clickable]: onClick,
        })}
        onClick={onClick}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        data-test-id="notification"
      >
        {isValidElement(NOTIFICATION_ICONS[type]) && (
          <div className={styles.icon}>{NOTIFICATION_ICONS[type]}</div>
        )}

        <Text
          className={styles.content}
          lineHeight={isMobile ? "short" : "long"}
        >
          {content}
        </Text>

        <Button
          type="icon"
          htmlType="button"
          aria-label="Закрыть уведомление"
          className={styles["close-button"]}
          dataTestId="notification-close-button"
          onClick={handleClose}
        >
          <CloseIcon theme="dark" />
        </Button>
      </div>
    );
  }
);
